export const CONTENT_TYPE = {
	PARAGRAPH: 'PARAGRAPH',
	BULLET: 'BULLET',
	NUMBER: 'NUMBER',
	LISTING: 'LISTING',
	IMAGE: 'IMAGE',
	CURL: 'CURL',
	JSON: 'JSON',
	TABLE: 'TABLE',
	TABS: 'TABS',
	TAGS: 'TAGS'
};

export const headWeight = {
	'normal': 'normal',
	'large': '800',
	'bolder': '700',
	'bold': '900'
};

export const CURL_THEME = {
	'DARK': 'dark',
	'LIGHT': 'light'
};

export const curlStyles = {
	[CURL_THEME.DARK]: {
		'heading': '#C8CBCE',
		'headingBg': '#3D4255',
		'contentKey': '#FFF',
		'contentValue': '#CEFFB0',
		'contentBg': '#505669',
		'number': '#88889A',
		'defaultColor': '#FFF',
		'copyColor': '#C8CBCE',
		'bdrColor': 'transparent'
	},
	[CURL_THEME.LIGHT]: {
		'heading': '#374B63',
		'headingBg': '#fff',
		'contentKey': '#374B63',
		'contentValue': '#399B37',
		'contentBg': '#F8FAFC',
		'defaultColor': '#399B37',
		'copyColor': '#FF664B',
		'bdrColor': '#d8d8d8'
	}
};
